__turbopack_context__.v({
  "faq-block": "styles-module-scss-module__4opQ9W__faq-block",
  "faq-container": "styles-module-scss-module__4opQ9W__faq-container",
  "qa-container": "styles-module-scss-module__4opQ9W__qa-container",
});
